import { Avatar, Col, Form, Image, Input, Row, Space, Tooltip } from "antd";
import moment from "moment";
import React, { useEffect, useMemo } from "react";
import { UserOutlined } from "@ant-design/icons";
import { getImageSrc } from "pages/Receive/ExtendCard/config";
import { DataFormField } from "types/models/input-field-type";
import { InputFields } from "components/common";
import {
  birthday2Age,
  convertIosStringToDateDayjs,
  formatDateToString,
  convertDateStringToDateTimezone_7,
} from "helper/common";
import { FORMAT_TIME } from "types/enums";

type PatientInfoProps = {
  data: any;
  fields: DataFormField[];
  showHeader?: boolean;
};

const PatientInfoCommon = ({
  data,
  fields,
  showHeader = true,
}: PatientInfoProps) => {
  // console.log("🚀 ~ data:", data);
  const gender = () => {
    if (data) {
      if (data.gioiTinh === 0) {
        return "Nam";
      }
      if (data.gioiTinh === 1) {
        return "Nữ";
      }
    } else return "Không có";
  };

  return (
    <Row gutter={[16, 0]}>
      <Col className="avatar" flex="150px">
        <Form.Item name={"anh"}>
          {data?.anh ? (
            <Image
              width={140}
              height={"auto"}
              src={getImageSrc(data.anh)}
              preview={false}
            />
          ) : (
            <Avatar icon={<UserOutlined />} shape="square" size={140} />
          )}
        </Form.Item>
      </Col>
      <Col flex={"1 0 0"}>
        <Space direction="vertical" size={"middle"}>
          {showHeader && (
            <Row gutter={[16, 8]}>
              <Form.Item
                initialValue={null}
                className="form"
                name="hoTenBN"
                style={{ fontWeight: "bold" }}
              >
                {(data?.hoTen ||
                  data?.hoTenBN ||
                  data?.hoVaTen ||
                  data?.tenBenhNhan) ??
                  "Không có"}{" "}
                -
              </Form.Item>
              <Form.Item
                initialValue={null}
                className="form"
                style={{ fontWeight: "bold" }}
                name="gioiTinh"
              >
                &nbsp;
                {gender()} -
              </Form.Item>

              <Form.Item
                initialValue={null}
                name="ngaySinh"
                style={{ fontWeight: "bold" }}
                className="form"
              >
                &nbsp;
                {birthday2Age(data?.ngaySinh)}{" "}
                {birthday2Age(data?.ngaySinh).toString().includes("tháng")
                  ? ""
                  : "tuổi"}
                &nbsp;(SN:&nbsp;
                {data?.ngaySinh
                  ? convertDateStringToDateTimezone_7(data?.ngaySinh).format(
                      FORMAT_TIME.dayFull
                    )
                  : "Không có"}
                ) -
              </Form.Item>

              <Form.Item
                initialValue={null}
                className="form"
                style={{ fontWeight: "bold" }}
                name="idBenhNhan"
              >
                &nbsp;
                <Tooltip title={"Mã bệnh nhân"}>
                  {(data?.idBenhNhan || data?.maBenhNhan) ?? "Không có"} -
                </Tooltip>
              </Form.Item>
              <Form.Item
                initialValue={null}
                className="form"
                style={{ fontWeight: "bold" }}
                name="idPhieuKham"
              >
                &nbsp;
                <Tooltip title={"Mã phiếu khám"}>
                  {(data?.idPhieuKham || data?.maKhamBenh) ?? "Không có"}
                </Tooltip>
              </Form.Item>
            </Row>
          )}

          <Row gutter={[16, 8]}>
            <InputFields data={fields} />
            {/* {(data?.chanDoan ||
              data?.icdChanDoan ||
              data?.idChanDoanVaoVien ||
              data?.chanDoanVaoVien) && (
              <Col xl={16} md={24} lg={12}>
                <Form.Item
                  initialValue={
                    `${
                      data?.icdChanDoan
                        ? data?.icdChanDoan.replace("\n", "") + "-"
                        : ""
                    } ${data?.chanDoan?.replace("\n", "")}`
                    // `${
                    //   data?.idChanDoanVaoVien
                    //     ? data?.idChanDoanVaoVien.replace("\n", "") + "-"
                    //     : ""
                    // } ${data?.chanDoanVaoVien?.replace("\n", "")}`
                  }
                  className="form"
                  name="chanDoan"
                  label="Chẩn đoán"
                  labelCol={{ xl: 3, md: 8 }}
                  labelAlign="left"
                  wrapperCol={{ xl: 21, md: 16 }}
                >
                  <TextArea disabled />
                </Form.Item>
              </Col>
            )} */}
          </Row>
        </Space>
      </Col>
    </Row>
  );
};
export default PatientInfoCommon;
